<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></h1>
<p class="P_Normal">Many thanks to Lee Brazil and Havan Fellows for their continued support and cheerleading as my writing and this series in particular have taken shape. You both rock! Huge thanks to Fred, who makes every day feel like a first date. I love you more than words can say.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?cede4c28